import { NgModule } from '@angular/core'
import { GetContrastColorPipe } from './get-contrast-color.pipe'

/**
 * Shared list of core pipes exported by `PipesModule`.
 */
const pipes = [GetContrastColorPipe]

@NgModule({
    imports: [...pipes],
    providers: pipes,
    exports: pipes,
})
/**
 * Bundles the app's reusable core pipes for module-based consumers.
 */
export class PipesModule {}
